import { Component } from "react";
import { SupportApiManager } from "../supportApiManager";
import { 
    Button,
    CloseButton,
    Container,
    FormControl,
    InputGroup,
    ListGroup,
    ListGroupItem,
    Stack,
    Modal
} from "react-bootstrap";

export class SchoolList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            newSchool: '',
        }
        this.apiManager = new SupportApiManager()
    }

    async componentDidMount() {
        await this.getSchoolsForDistrict(this.props.districtCode)
    }

    async componentDidUpdate(prevProps) {
        if (this.props.districtCode !== prevProps.districtCode) {
            await this.getSchoolsForDistrict(this.props.districtCode)
        }
    }

    async getSchoolsForDistrict(districtCode) {
        const schools = await this.apiManager.getSchoolsForDistrict(districtCode)
        this.setState({focusedDistrictSchools: schools})
    }

    async removeSchoolFromDistrict(school) {
        const res = await this.apiManager.removeSchoolFromDistrict(this.props.districtCode, school)
        if (res) {
            this.updateDeleteSchoolValue(undefined)
            this.props.updateAdminList()
            await this.getSchoolsForDistrict(this.props.districtCode)
        }
    }

    createNewSchoolForDistrict = async () => {
        if (!this.state.newSchool) {
            alert('New school must not be empty')
            return
        }
        if (this.state.focusedDistrictSchools && this.state.focusedDistrictSchools.some(school => school === this.state.newSchool)) {
            alert('New school cannot be the same as an existing school in the district')
            return
        }
        const result = await this.apiManager.addSchool(this.props.districtCode, this.state.newSchool)
        if (result) {
            this.setState({newSchool: ''})
            alert(`Added new school, ${this.state.newSchool}, for district ${this.props.districtCode}`)
            this.getSchoolsForDistrict(this.props.districtCode)
        }
    }

    updateSchoolValue = (e) => {
        this.setState({
            newSchool: e.target.value,
        })
    }

    updateDeleteSchoolValue = (value) => {
        this.setState({
            schoolDeleteModal: value,
        })
    }

    render() {
        return (<>
            <Container className="mt-3">
                <h5>Schools</h5>
                <ListGroup>
                    {this.state.focusedDistrictSchools && this.state.focusedDistrictSchools.map((item, idx) =>
                        <ListGroupItem key={idx}>
                            <Stack direction="horizontal" className="justify-content-between">
                                <span>{item}</span>
                                <CloseButton onClick={() => this.updateDeleteSchoolValue(item)} />
                            </Stack>
                        </ListGroupItem>  
                    )}
                    {(!this.state.focusedDistrictSchools || this.state.focusedDistrictSchools.length === 0) &&
                        <ListGroupItem>No schools in district</ListGroupItem>
                    }
                </ListGroup>
                <InputGroup className="mt-2">
                    <FormControl value={this.state.newSchool} onChange={this.updateSchoolValue} placeholder="School name" />
                    <Button onClick={() => this.createNewSchoolForDistrict()}>Add school</Button>
                </InputGroup>
            </Container>

             {/* MODALS */}
             <Modal show={!!this.state.schoolDeleteModal} onHide={() => {this.updateDeleteSchoolValue(undefined)}}>
                <Modal.Header>
                    <Modal.Title>Are you sure you wish to remove this school from its district?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>This will also remove admins assigned to this school.</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => {this.updateDeleteSchoolValue(undefined)}}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={() => {this.removeSchoolFromDistrict(this.state.schoolDeleteModal)}}>
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>
        </>)
    }
}